import request from '@/utils/request';

// 每月活动记录列表
export function getActivityRecordLists(data) {
  return request({
    url: '/wap/activity/get_activity_record_lists',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 活动详情
export function getActivityRecordInfo(data) {
  return request({
    url: '/wap/activity/get_activity_record_info',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 活动-我的参与奖券列表
export function getActivityMemberTicketLists(data) {
  return request({
    url: '/wap/activity/get_activity_member_ticket_lists',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
